import { IElement } from "core-integration/src/store/elements/types";
import { IEvent } from "core-integration/src/store/events/types";
import {
  FixturesByEvent,
  IFixture,
} from "core-integration/src/store/fixtures/types";

export const getNextElementFixtures = (
  nextEvent: IEvent | null,
  numberOfFixtures: number,
  fixturesByEvent: FixturesByEvent,
  element: IElement,
) => {
  const elementFixtures: any[] = [];
  if (nextEvent) {
    for (let i = 0; i < numberOfFixtures; i++) {
      const eventId = nextEvent.id + i;
      if (fixturesByEvent[eventId]) {
        // No chance of a team having more than one fixture
        const fixture = fixturesByEvent[eventId].find(
          (f: any) => f.team_h === element.team || f.team_a === element.team,
        );
        if (fixture) {
          elementFixtures[i] = fixture;
        } else {
          elementFixtures[i] = { code: null };
        }
      }
    }
  }
  return elementFixtures;
};

export const getOpponentTeam = (elementTeam: number, fixture: IFixture) => {
  return elementTeam === fixture.team_h ? fixture.team_a : fixture.team_h;
};
